import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="border-t border-black/5 bg-white/50 mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-8 gap-y-12 mb-14">
          <div className="col-span-2 sm:col-span-1 sm:pr-6">
            <img src="/logo.png" alt="JobVinum" className="h-8 w-auto mb-3" />
            <p className="text-sm text-[#2B2B2B]/60 max-w-xs">{t("landing.footerTagline")}</p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wide text-[#2B2B2B]/40 mb-4">{t("landing.footerPlatform")}</h4>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/offers" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-offers-link">{t("nav.offers")}</Link>
              <Link to="/candidates" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-candidates-link">{t("nav.candidates")}</Link>
              <Link to="/register" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-register-link">{t("nav.register")}</Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wide text-[#2B2B2B]/40 mb-4">{t("landing.footerResources")}</h4>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/blog" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-blog-link">{t("nav.blog")}</Link>
              <Link to="/roadmap" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-roadmap-link">{t("nav.roadmap")}</Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-wide text-[#2B2B2B]/40 mb-4">{t("landing.footerLegal")}</h4>
            <div className="flex flex-col gap-3 text-sm">
              <Link to="/cguv" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-cguv-link">{t("legal.cguv")}</Link>
              <Link to="/mentions-legales" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-mentions-legales-link">{t("legal.mentionsLegales")}</Link>
              <Link to="/politique-confidentialite" className="text-[#2B2B2B]/70 hover:text-[#4ba3b7] transition-colors" data-testid="footer-politique-confidentialite-link">{t("legal.politiqueConfidentialite")}</Link>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-black/5">
          <p className="text-xs text-[#2B2B2B]/40">
            &copy; {new Date().getFullYear()} JobVinum. {t("landing.footerRights")}
          </p>
        </div>
      </div>
    </footer>
  );
}
